import { useCallback, useState } from "react";

const initialFeedback = {
  mood: "VERY_CALM",
  therapyRating: 4,
  factors: ["THERAPIST_BEHAVIOUR", "THERAPY_EFFECTIVENESS"],
  otherFactor: "",
  stressBefore: 9,
  stressAfter: 4,
  improvements: [
    "BETTER_SLEEP",
    "BETTER_BREATHING",
    "LESS_ANXIETY",
    "REDUCED_PAIN",
    "BETTER_MOOD",
    "IMPROVED_FOCUS",
    "MORE_ENERGY",
    "EMOTIONALLY_LIGHTER",
    "MORE_HOPEFUL",
  ],
  improvementOther: "",
  experience: { Q001: 5, Q002: 5, Q003: 5, Q004: 4, Q005: 5 },
  comment: "",
};
export function useFeedbackForm() {
  const [feedback, setFeedback] = useState(initialFeedback);

  const updateFeedback = useCallback((field, value) => {
    setFeedback((currentFeedback) => ({
      ...currentFeedback,
      [field]: value,
    }));
  }, []);
  const updateFeedbackEntry = useCallback((field, key, value) => {
    setFeedback((currentFeedback) => ({
      ...currentFeedback,
      [field]: {
        ...currentFeedback[field],
        [key]: value,
      },
    }));
  }, []);
  const toggleFeedbackOption = useCallback((field, value) => {
    setFeedback((currentFeedback) => {
      const selectedValues = Array.isArray(currentFeedback[field])
        ? currentFeedback[field]
        : [];
      const nextValues = selectedValues.includes(value)
        ? selectedValues.filter((selectedValue) => selectedValue !== value)
        : [...selectedValues, value];

      return {
        ...currentFeedback,
        [field]: nextValues,
      };
    });
  }, []);
  const toggleImprovement = useCallback((value) => {
    setFeedback((currentFeedback) => {
      const currentImprovements = currentFeedback.improvements;
      let nextImprovements;

      if (value === "NO_CHANGE") {
        nextImprovements = currentImprovements.includes("NO_CHANGE")
          ? []
          : ["NO_CHANGE"];
      } else {
        const improvementsWithoutNoChange = currentImprovements.filter(
          (improvement) => improvement !== "NO_CHANGE",
        );
        nextImprovements = improvementsWithoutNoChange.includes(value)
          ? improvementsWithoutNoChange.filter(
              (improvement) => improvement !== value,
            )
          : [...improvementsWithoutNoChange, value];
      }

      return {
        ...currentFeedback,
        improvements: nextImprovements,
      };
    });
  }, []);
  const resetFeedback = useCallback(() => {
    setFeedback(initialFeedback);
  }, []);

  return {
    feedback,
    updateFeedback,
    updateFeedbackEntry,
    toggleFeedbackOption,
    toggleImprovement,
    resetFeedback,
  };
}
